import qs from "qs";
import Axios from "axios";

export class MorningCoin {
  constructor(apiUrl, headers) {
    // Set morning coin url
    this.mncUrl = `${apiUrl}/morning-coin`;
    
    this.headers = headers;
  }

  async getWalletNames(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true, indices: false
    });
    
    const url = `${this.mncUrl}/wallet-names${queryString}`;
    const response = await Axios.get(
      url, { headers: this.headers }
    );

    return response; 
  }

  async getCoins() {
    const url = `${this.mncUrl}/coins`;
    
    const response = await Axios.get(
      url, { headers: this.headers }
    );

    return response; 
  }

  async getReportBalances(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true, indices: false
    });

    const url = `${this.mncUrl}/report/balances${queryString}`;

    const response = await Axios.get(
      url, { headers: this.headers }
    );

    return response
  }

  async downloadReportBalances() {
    const url = `${this.mncUrl}/report/balances/download`;

    const blobHeaders = {
      ...this.headers,
      Accept: "application/octet-stream",
    };

    const response = await Axios.get(
      url, { headers: blobHeaders, responseType: "blob" }
    );

    return response
  }

  async getUserBalanceByUserId(userId) {
    const url = `${this.mncUrl}/report/balances/${userId}`;

    const response = await Axios.get(
      url, { headers: this.headers }
    );

    return response
  }

  async getTransactionsByUserId(userId, query) {
    const queryString = qs.stringify(query, {
      addQueryPrefix: true, indices: false
    });

    const url = `${this.mncUrl}/report/transactions/${userId}${queryString}`;
    
    const response = await Axios.get(
      url, { headers: this.headers }
    );

    return response; 
  }

  async downloadReportTransactionsByUserId(userId) {
    const url = `${this.mncUrl}/report/transactions/${userId}/download`;

    const blobHeaders = {
      ...this.headers,
      Accept: "application/octet-stream",
    };

    const response = await Axios.get(
      url, { headers: blobHeaders, responseType: "blob" }
    );

    return response
  }

  async bulkTransferFromOrg(params) {
    const url = `${this.mncUrl}/bulk-transfer-from-org`;

    const response = await Axios.post(url, params, { headers: this.headers });

    return response;
  }

}
